import { React, useState, useRef, useEffect } from "react";
import AgentLayout from "../components/AgentLayout";
import "../../../assets/css/betfair_games.css";
import useSocket from "../../../hooks/useSocket";
import "../../../assets/css/betfair_games.css";
import "../../../assets/css/betfair_games_lo2.css";
import axiosInstance from "../../../utils/axiosInstance";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AgentBetfairTurboBlackjack = () => {
    const dispatch = useDispatch();
    const [showBetSlip, setShowBetSlip] = useState(false);
    const [placeBetObject, setPlaceBetObject] = useState({});
    const [betErrorMessageObj, setBetErrorMessage] = useState({});
    const [stakeList, setStakeList] = useState({});
    const [getBetDelayTime, setGetBetDelayTime] = useState([]);

    const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
    const [betButtonShow, setBetButtonShow] = useState(true);
    const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
    const [profileData, setProfileData] = useState(null);

    const [books, setBooks] = useState({});
    const [betList, setBetList] = useState([]);
    const [totalBets, setTotalBets] = useState(0);
    const [showResult, setShowResult] = useState(false);
    const [resultData, setResultData] = useState([]);
    const [showModal, setShowModal] = useState(false);

    let betfairOdds = null;
    const { data, isConnected } = useSocket({
        marketId: null,
        mtype: "bfgames",
        type: "turbo_blackjack"
    });
    //console.log("Socket data:", data);

    let evt_status = "";
    let roundId = "";
    let timeLeft = "";
    let time_percentage = "";
    let round = "";

    let runner1b1 = "";
    let runner1b2 = "";
    let runner1b3 = "";
    let runner1l1 = "";
    let runner1l2 = "";
    let runner1l3 = "";
    let runner2b1 = "";
    let runner2b2 = "";
    let runner2b3 = "";
    let runner2l1 = "";
    let runner2l2 = "";
    let runner2l3 = "";
    let runner3b1 = "";
    let runner3b2 = "";
    let runner3b3 = "";
    let runner3l1 = "";
    let runner3l2 = "";
    let runner3l3 = "";
    let runner4b1 = "";
    let runner4b2 = "";
    let runner4b3 = "";
    let runner4l1 = "";
    let runner4l2 = "";
    let runner4l3 = "";
    let runner5b1 = "";
    let runner5b2 = "";
    let runner5b3 = "";
    let runner5l1 = "";
    let runner5l2 = "";
    let runner5l3 = "";
    let runner6b1 = "";
    let runner6b2 = "";
    let runner6b3 = "";
    let runner6l1 = "";
    let runner6l2 = "";
    let runner6l3 = "";
    let runner7b1 = "";
    let runner7b2 = "";
    let runner7b3 = "";
    let runner7l1 = "";
    let runner7l2 = "";
    let runner7l3 = "";
    let runner8b1 = "";
    let runner8b2 = "";
    let runner8b3 = "";
    let runner8l1 = "";
    let runner8l2 = "";
    let runner8l3 = "";

    let runner1b1_matched = "";
    let runner1b2_matched = "";
    let runner1b3_matched = "";
    let runner1l1_matched = "";
    let runner1l2_matched = "";
    let runner1l3_matched = "";
    let runner2b1_matched = "";
    let runner2b2_matched = "";
    let runner2b3_matched = "";
    let runner2l1_matched = "";
    let runner2l2_matched = "";
    let runner2l3_matched = "";
    let runner3b1_matched = "";
    let runner3b2_matched = "";
    let runner3b3_matched = "";
    let runner3l1_matched = "";
    let runner3l2_matched = "";
    let runner3l3_matched = "";
    let runner4b1_matched = "";
    let runner4b2_matched = "";
    let runner4b3_matched = "";
    let runner4l1_matched = "";
    let runner4l2_matched = "";
    let runner4l3_matched = "";
    let runner5b1_matched = "";
    let runner5b2_matched = "";
    let runner5b3_matched = "";
    let runner5l1_matched = "";
    let runner5l2_matched = "";
    let runner5l3_matched = "";
    let runner6b1_matched = "";
    let runner6b2_matched = "";
    let runner6b3_matched = "";
    let runner6l1_matched = "";
    let runner6l2_matched = "";
    let runner6l3_matched = "";
    let runner7b1_matched = "";
    let runner7b2_matched = "";
    let runner7b3_matched = "";
    let runner7l1_matched = "";
    let runner7l2_matched = "";
    let runner7l3_matched = "";
    let runner8b1_matched = "";
    let runner8b2_matched = "";
    let runner8b3_matched = "";
    let runner8l1_matched = "";
    let runner8l2_matched = "";
    let runner8l3_matched = "";

    let rnr1_status = "";
    let rnr2_status = "";
    let rnr3_status = "";
    let rnr4_status = "";
    let rnr5_status = "";
    let rnr6_status = "";
    let rnr7_status = "";
    let rnr8_status = "";

    let suspend1 = "";
    let suspend2 = "";
    let suspend3 = "";
    let suspend4 = "";
    let suspend5 = "";
    let suspend6 = "";
    let suspend7 = "";
    let suspend8 = "";

    let cards_desc = "";
    let cardsDesc = "";

    let rnr1_desc = "";
    let rnr2_desc = "";
    let rnr3_desc = "";
    let rnr4_desc = "";

    let cardsDesc1 = "";
    let cardsDesc2 = "";
    let cardsDesc3 = "";
    let cardsDesc4 = "";
    let max = -219.99078369140625;
    const updateUserData = async (userData) => {
        await dispatch(setUserData(userData));
    };
    if (data != null && data.data !== null && data.data !== undefined) {
        betfairOdds = data.data;
        updateUserData(data?.user);

        roundId = betfairOdds.roundId;
        evt_status = betfairOdds.evt_status;
        timeLeft = betfairOdds.timeLeft;
        time_percentage = betfairOdds.time_percentage;
        round = betfairOdds.round;

        runner1b1 = betfairOdds.runner1b1;
        runner1b2 = betfairOdds.runner1b2;
        runner1b3 = betfairOdds.runner1b3;
        runner1l1 = betfairOdds.runner1l1;
        runner1l2 = betfairOdds.runner1l2;
        runner1l3 = betfairOdds.runner1l3;
        runner2b1 = betfairOdds.runner2b1;
        runner2b2 = betfairOdds.runner2b2;
        runner2b3 = betfairOdds.runner2b3;
        runner2l1 = betfairOdds.runner2l1;
        runner2l2 = betfairOdds.runner2l2;
        runner2l3 = betfairOdds.runner2l3;
        runner3b1 = betfairOdds.runner3b1;
        runner3b2 = betfairOdds.runner3b2;
        runner3b3 = betfairOdds.runner3b3;
        runner3l1 = betfairOdds.runner3l1;
        runner3l2 = betfairOdds.runner3l2;
        runner3l3 = betfairOdds.runner3l3;
        runner4b1 = betfairOdds.runner4b1;
        runner4b2 = betfairOdds.runner4b2;
        runner4b3 = betfairOdds.runner4b3;
        runner4l1 = betfairOdds.runner4l1;
        runner4l2 = betfairOdds.runner4l2;
        runner4l3 = betfairOdds.runner4l3;
        runner5b1 = betfairOdds.runner5b1;
        runner5b2 = betfairOdds.runner5b2;
        runner5b3 = betfairOdds.runner5b3;
        runner5l1 = betfairOdds.runner5l1;
        runner5l2 = betfairOdds.runner5l2;
        runner5l3 = betfairOdds.runner5l3;
        runner6b1 = betfairOdds.runner6b1;
        runner6b2 = betfairOdds.runner6b2;
        runner6b3 = betfairOdds.runner6b3;
        runner6l1 = betfairOdds.runner6l1;
        runner6l2 = betfairOdds.runner6l2;
        runner6l3 = betfairOdds.runner6l3;
        runner7b1 = betfairOdds.runner7b1;
        runner7b2 = betfairOdds.runner7b2;
        runner7b3 = betfairOdds.runner7b3;
        runner7l1 = betfairOdds.runner7l1;
        runner7l2 = betfairOdds.runner7l2;
        runner7l3 = betfairOdds.runner7l3;
        runner8b1 = betfairOdds.runner8b1;
        runner8b2 = betfairOdds.runner8b2;
        runner8b3 = betfairOdds.runner8b3;
        runner8l1 = betfairOdds.runner8l1;
        runner8l2 = betfairOdds.runner8l2;
        runner8l3 = betfairOdds.runner8l3;

        runner1b1_matched = betfairOdds.runner1b1_matched;
        runner1b2_matched = betfairOdds.runner1b2_matched;
        runner1b3_matched = betfairOdds.runner1b3_matched;
        runner1l1_matched = betfairOdds.runner1l1_matched;
        runner1l2_matched = betfairOdds.runner1l2_matched;
        runner1l3_matched = betfairOdds.runner1l3_matched;
        runner2b1_matched = betfairOdds.runner2b1_matched;
        runner2b2_matched = betfairOdds.runner2b2_matched;
        runner2b3_matched = betfairOdds.runner2b3_matched;
        runner2l1_matched = betfairOdds.runner2l1_matched;
        runner2l2_matched = betfairOdds.runner2l2_matched;
        runner2l3_matched = betfairOdds.runner2l3_matched;
        runner3b1_matched = betfairOdds.runner3b1_matched;
        runner3b2_matched = betfairOdds.runner3b2_matched;
        runner3b3_matched = betfairOdds.runner3b3_matched;
        runner3l1_matched = betfairOdds.runner3l1_matched;
        runner3l2_matched = betfairOdds.runner3l2_matched;
        runner3l3_matched = betfairOdds.runner3l3_matched;
        runner4b1_matched = betfairOdds.runner4b1_matched;
        runner4b2_matched = betfairOdds.runner4b2_matched;
        runner4b3_matched = betfairOdds.runner4b3_matched;
        runner4l1_matched = betfairOdds.runner4l1_matched;
        runner4l2_matched = betfairOdds.runner4l2_matched;
        runner4l3_matched = betfairOdds.runner4l3_matched;
        runner5b1_matched = betfairOdds.runner5b1_matched;
        runner5b2_matched = betfairOdds.runner5b2_matched;
        runner5b3_matched = betfairOdds.runner5b3_matched;
        runner5l1_matched = betfairOdds.runner5l1_matched;
        runner5l2_matched = betfairOdds.runner5l2_matched;
        runner5l3_matched = betfairOdds.runner5l3_matched;
        runner6b1_matched = betfairOdds.runner6b1_matched;
        runner6b2_matched = betfairOdds.runner6b2_matched;
        runner6b3_matched = betfairOdds.runner6b3_matched;
        runner6l1_matched = betfairOdds.runner6l1_matched;
        runner6l2_matched = betfairOdds.runner6l2_matched;
        runner6l3_matched = betfairOdds.runner6l3_matched;
        runner7b1_matched = betfairOdds.runner7b1_matched;
        runner7b2_matched = betfairOdds.runner7b2_matched;
        runner7b3_matched = betfairOdds.runner7b3_matched;
        runner7l1_matched = betfairOdds.runner7l1_matched;
        runner7l2_matched = betfairOdds.runner7l2_matched;
        runner7l3_matched = betfairOdds.runner7l3_matched;
        runner8b1_matched = betfairOdds.runner8b1_matched;
        runner8b2_matched = betfairOdds.runner8b2_matched;
        runner8b3_matched = betfairOdds.runner8b3_matched;
        runner8l1_matched = betfairOdds.runner8l1_matched;
        runner8l2_matched = betfairOdds.runner8l2_matched;
        runner8l3_matched = betfairOdds.runner8l3_matched;

        rnr1_status = betfairOdds.rnr1_status;
        rnr2_status = betfairOdds.rnr2_status;
        rnr3_status = betfairOdds.rnr3_status;
        rnr4_status = betfairOdds.rnr4_status;
        rnr5_status = betfairOdds.rnr5_status;
        rnr6_status = betfairOdds.rnr6_status;
        rnr7_status = betfairOdds.rnr7_status;
        rnr8_status = betfairOdds.rnr8_status;

        suspend1 = betfairOdds.suspend1;
        suspend2 = betfairOdds.suspend2;
        suspend3 = betfairOdds.suspend3;
        suspend4 = betfairOdds.suspend4;
        suspend5 = betfairOdds.suspend5;
        suspend6 = betfairOdds.suspend6;
        suspend7 = betfairOdds.suspend7;
        suspend8 = betfairOdds.suspend8;

        if (evt_status == "SUSPENDED_GAME_ROUND_OVER") {
            if (rnr1_status != "IN_PLAY") {
                rnr1_status = rnr1_status;
            } else {
                rnr1_status = "ROUND OVER !";
            }

            if (rnr2_status != "IN_PLAY") {
                rnr2_status = rnr2_status;
            } else {
                rnr2_status = "ROUND OVER !";
            }

            if (rnr3_status != "IN_PLAY") {
                rnr3_status = rnr3_status;
            } else {
                rnr3_status = "ROUND OVER !";
            }

            if (rnr4_status != "IN_PLAY") {
                rnr4_status = rnr4_status;
            } else {
                rnr4_status = "ROUND OVER !";
            }

            if (rnr5_status != "IN_PLAY") {
                rnr5_status = rnr5_status;
            } else {
                rnr5_status = "ROUND OVER !";
            }

            if (rnr6_status != "IN_PLAY") {
                rnr6_status = rnr6_status;
            } else {
                rnr6_status = "ROUND OVER !";
            }

            if (rnr7_status != "IN_PLAY") {
                rnr7_status = rnr7_status;
            } else {
                rnr7_status = "ROUND OVER !";
            }

            if (rnr8_status != "IN_PLAY") {
                rnr8_status = rnr8_status;
            } else {
                rnr8_status = "ROUND OVER !";
            }
        }

        ///
        cards_desc = betfairOdds.cards_desc;
        cardsDesc = cards_desc.split(",");

        rnr1_desc = betfairOdds.rnr1_desc;
        cardsDesc1 = rnr1_desc.split(",");
        rnr2_desc = betfairOdds.rnr2_desc;
        cardsDesc2 = rnr2_desc.split(",");
        rnr3_desc = betfairOdds.rnr3_desc;
        cardsDesc3 = rnr3_desc.split(",");
        rnr4_desc = betfairOdds.rnr4_desc;
        cardsDesc4 = rnr4_desc.split(",");
    }
    const getCardImage = (cardValue) => {
        if (cardValue === "NOT AVAILABLE") {
            return `/assets/images/bpstudio/cards/card_simple_omaha_back_bf.svg`;
        }

        if (["28", "33", "39", "40"].includes(cardValue)) {
            return `/assets/images/bpstudio/cards/card_simple_${cardValue}.png`;
        }

        return `/assets/images/bpstudio/cards/card_simple_${cardValue}.svg`;
    };

    /// place bet ///

    const showBetfairBetSlip = (bettype, teamname, selectRnr, price) => {
        if (price <= 0) {
            return;
        }

        let placeBetObject = {
            amount: 0,
            catmid: "",
            market_type: "m",
            game_name: "betfair_turbo_blackjack"
        };
        placeBetObject.catmid = roundId;
        placeBetObject.round = round;
        //console.log(placeBetObject);
        placeBetObject.odds = price;
        placeBetObject.teamname = teamname;
        placeBetObject.bettype = bettype;
        placeBetObject.selectRnr = selectRnr;
        placeBetObject.marketVal = 1;
        placeBetObject.game_type = 9;

        setPlaceBetObject(placeBetObject);
        console.log("isMobile: ", isMobile);
        if (isMobile) {
            setShowBetSlipPopup(true);
        } else {
            setShowBetSlip(true);
        }
        //showBetfairSlipStatus = true;
    };

    const closeBetSlipMobile = () => {
        setShowBetSlipPopup(false);
        setBetErrorMessage({});
    };
    /// place bet ///

    const closeBetSlip = () => {
        setShowBetSlip(false);
    };
    const getDelayTimes = async () => {
        try {
            const { data } = await axiosInstance.get("/profile/event-limits");
            setGetBetDelayTime(data);
        } catch (error) {
            console.error("Failed to load getDelayTimes data:", error);
        }
    };

    const delayTime = (game_type) => {
        let defaultTime = 8;
        if (getBetDelayTime) {
            for (let i = 0; i < getBetDelayTime?.length; i++) {
                let obj = getBetDelayTime[i];
                if (game_type == 7) {
                    defaultTime = obj.value;
                    break;
                }
            }
        }

        return defaultTime;
    };

    const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

    const placeBet = async (amount, profit) => {
        placeBetObject.amount = amount;
        placeBetObject.profit = profit;
        console.log(placeBetObject);
        let delay = delayTime(7);
        try {
            await sleep(delay * 1000);
            const response = await axiosInstance.post(
                "/betfair-turbo-blackjack",
                placeBetObject
            );
            console.log(response);
            if (
                response.data !== undefined &&
                response.data !== null &&
                response.data.status !== undefined &&
                response.data.status !== null
            ) {
                let messageObj = {};
                if (response.data.status) {
                    messageObj.status = true;
                } else {
                    messageObj.status = false;
                }
                messageObj.message = response.data.message;
                toast.success(response.data.message);
                setBetErrorMessage(messageObj);
                setShowBetSlipPopup(false);
                //getBook(placeBetObject.catmid);
                fetchUserData(); //balance update on top
                getBook();
            }
        } catch (error) {
            if (error.response.data !== undefined && error.response.data !== null) {
                if (
                    error.response.data.status !== undefined &&
                    error.response.data.status !== null &&
                    error.response.data.status === false
                ) {
                    let errorMessage = error.response.data.message;
                    let messageObj = {};
                    messageObj.status = false;
                    messageObj.message = errorMessage;
                    setBetErrorMessage(messageObj);
                    toast.error(errorMessage);
                }
            }
        }
    };

    const fetchProfile = async () => {
        try {
            const { data } = await axiosInstance.get("/profile");
            setProfileData(data);

            setStakeList({
                stake1: data.stake1,
                stake2: data.stake2,
                stake3: data.stake3,
                stake4: data.stake4,
                stake5: data.stake5,
                stake6: data.stake6,
                stake7: data.stake7,
                stake8: data.stake8
            });
        } catch (error) {
            console.log("Failed to load profile data:", error);
        }
    };

    useEffect(() => {
        fetchProfile();
        getDelayTimes();
    }, []);

    const fetchUserData = async () => {
        //console.log("Fetching events...");
        try {
            const response = await axiosInstance.get("/user");
            //console.log("user-response->",response);
            if (response.data !== "") {
                await dispatch(setUserData(response.data));
            }
        } catch (error) {
            console.error("Error fetching events:", error);
        }
    };

    const getBook = async () => {
        let bookObject = {};
        bookObject.roundId = roundId;
        bookObject.game_type = "betfair-turbo-blackjack";

        const response = await axiosInstance.post("/betfair-book", bookObject);
        console.log("response->", response.data);
        ///
        let userbook = response.data.userbook;
        let bet_list = response.data.bets_list;
        const bookObj = {};
        if (userbook.length > 0) {
            let z = 0;
            const maxBooks = 8; // maximum number of dynamic variables you want
            for (let i = 1; i <= maxBooks; i++) {
                bookObj[`bookB${i}`] = "";
                bookObj[`bookL${i}`] = "";
            }
            setBooks(bookObj);
            for (let x = 0; x < userbook.length; x++) {
                z++;
                let splitSid = userbook[x].rnr_sid.split("-");
                let bookVal = splitSid[1];
                bookObj[`bookB${bookVal}`] = userbook[x].bak;
                bookObj[`bookL${bookVal}`] = userbook[x].lay;
            }
            setBooks(bookObj);
        } else {
            const maxBooks = 8; // maximum number of dynamic variables you want
            for (let i = 1; i <= maxBooks; i++) {
                bookObj[`bookB${i}`] = "";
                bookObj[`bookL${i}`] = "";
            }
            setBooks(bookObj);
        }

        if (bet_list.length > 0) {
            setTotalBets(bet_list.length);
            setBetList(bet_list);
        } else {
            setBetList([]);
        }

        ///
        return response;
    };

    useEffect(
        (roundId) => {
            getBook();
        },
        [roundId]
    ); // Empty dependency array

    const showResultDetail = async () => {
        let resultObj = {};
        resultObj.game_type = "betfair-turbo-blackjack";

        const response = await axiosInstance.post("/betfair-results", resultObj);

        setResultData(response.data.results_list);
        console.log("response->", resultData);
        setShowResult(true);
    };

    const hideResultDetail = async () => {
        setShowResult(false);
    };

    ///
    const tableStyle = { width: "100%", borderCollapse: "collapse" };
    const rowFlexStyle = {
        display: "flex",
        justifyContent: "center",
        background: "transparent"
    };
    const tdResultsStyle = {
        padding: "0px 0px 0px 0px",
        flex: "1 1 auto",
        boxSizing: "border-box",
        height: "110px"
    };
    const communityTdResultsStyle = {
        padding: "0px 0px 0px 0px",
        flex: "1 1 auto",
        boxSizing: "border-box",
        minHeight: "90px"
    };
    const playerCardsStyle = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflowWrap: "break-word"
    };
    const playerNameStyle = {
        fontWeight: "bold",
        textAlign: "center",
        width: "100%"
    };
    const cardImagesStyle = {
        display: "flex",
        justifyContent: "center",
        gap: 2,
        flexWrap: "wrap",
        width: "100%"
    };
    const cardImgStyle = {
        width: 40,
        height: 60,
        objectFit: "cover",
        borderRadius: 5
    };
    const playerStatusStyle = {
        color: "#000",
        marginTop: 5,
        fontSize: 14,
        fontWeight: "bold",
        textAlign: "center",
        width: "100%"
    };
    ///
    const closeButton = () => {
        setShowModal(false);
    };
    return (
      <AgentLayout>
        <style>
          {`
          .ExMainCardbundle .runner-position {
            bottom: 0px;
         }
          .ExMainCardbundle .runner-name {
              padding-top: 1px;
          }
          .TdResults {
            padding: 0;
            vertical-align: top;
            flex: 1 1 auto;
            box-sizing: border-box;
            max-width: calc(33.33% - 20px);
            min-width: 120px;
            background: linear-gradient(#535353, #0f0f0f);
            border-radius: 10px;
            margin: 1px;
        }
        .bgwinner {
            border-radius: 10px;
            background-color: #cf8d2e !important;
        }
        .bgLoser {
            border-radius: 10px;
            background-color: #cf3f3f !important;
        }
        .TdResultsWin {
            background: #008000 !important;
        }
        .player-card.stood, .andarbahar-player-card {
          margin-left:auto;
          margin-right:auto;
          min-height:auto;
        }
        .modal-content-style {
          max-width: 1000px !important;
          width: 100% !important;
          max-height: 95vh !important;
        }
        @media (max-width:768px) 
          {
            .community-cards td{
              display:block;
              box-sizing:border-box;
            }
            .community-cards{
              background:red !important;
              display:flex !important;
              flex-wrap:wrap;
              justify-content:center;
            }

            .players-table table{
              border-collapse: separate !important;
              border-spacing: 2px !important;
            }
            .players-table .community-cell {
              vertical-align: top;
              flex: 0 0 100% !important; 
              box-sizing: border-box;
              background: linear-gradient(#535353, #0f0f0f);
              border-radius: 10px;
              margin: 1px;
              max-width:100%;
            }
            .players-table table{
              width:100%;
              table-layout:auto;
            }
            .community-row td{
              width:100%;
            }
            .community-row .card-images img{
              margin:1px;
            }
            .card-images{
                display:flex;
                flex-wrap:nowrap;
                justify-content:flex-start;
                width:max-content !important;
            }
            .card-images img{
              display:inline-block;
            }
            .player-status{
              width: 160px !important;
            }
            .col-lg-8 {
              padding-left: 0px;
              padding-right: 0px;
            }
            .card-header { 
              padding: 0.3rem 0.25rem;
              border-bottom: 1px solid rgba(0, 0, 0, 0.125);
            }
            .hands-row{
              display:flex;
              flex-wrap:wrap;
            }
            .community-row{
              display:flex !important;
              flex-wrap:wrap !important;
              justify-content:center;
            }
            .community-row .TdResults{
              flex:0 1 auto !important; 
              min-width:160px;           
              max-width:none !important;
              margin:4px;
            }
            .players-table tbody tr:first-child .TdResults{
              width:100% !important;
              max-width:100% !important;
            }
            .players-table tbody tr:first-child{
              display:flex !important;
              width:100%;
            }
            .players-table tbody tr:nth-child(2){
              display:flex !important;
              flex-wrap:wrap !important;
              justify-content:center;
            }

            .players-table tbody tr:nth-child(2) .TdResults{
              flex:1 1 auto !important;
              min-width: 159px; 
              box-sizing:border-box;
              padding:4px;
            }
            .players-table tbody tr:nth-child(2) td{
              display:block !important; 
            }
          }
        `}
        </style>
        <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
          <div className="card ExMainCardbundle">
            <div className="card-header"></div>

            <div
              className="card-body mainexcard"
              id="afterAnimation"
              style={{ display: "block" }}
            >
              <div id="ExgamesDiv" className="row">
                <div className="col-lg-8 Exgamesbg">
                  <div className="x-game-header">
                    <div className="container text-center">
                      <center className="row">
                        <div className="col-md-4 ExRounds">
                          <div className="round-counter-simple">
                            <div className="round-counter-text">
                              <span className="i18n">Round</span>
                            </div>
                            <div
                              className={`round-counter-item-simple roundCounter ${
                                round == 1 ? "active" : ""
                              }`}
                              id="roundCounter1"
                            ></div>
                            <div
                              className={`round-counter-item-simple roundCounter ${
                                round == 2 ? "active" : ""
                              }`}
                              id="roundCounter2"
                            ></div>
                            <div
                              className={`round-counter-item-simple roundCounter ${
                                round == 3 ? "active" : ""
                              }`}
                              id="roundCounter3"
                            ></div>
                            <div
                              className={`round-counter-item-simple roundCounter ${
                                round == 4 ? "active" : ""
                              }`}
                              id="roundCounter4"
                            ></div>
                            <div
                              className={`round-counter-item-simple roundCounter ${
                                round == 5 ? "active" : ""
                              }`}
                              id="roundCounter5"
                            ></div>
                            <div
                              className={`round-counter-item-simple roundCounter ${
                                round == 6 ? "active" : ""
                              }`}
                              id="roundCounter6"
                            ></div>
                            <div
                              className={`round-counter-item-simple roundCounter ${
                                round == 7 ? "active" : ""
                              }`}
                              id="roundCounter7"
                            ></div>
                          </div>
                        </div>
                        <div className="col-4 col-md-4">
                          <div id="demoTimer" className="col">
                            <div className="base-timer casino-timer">
                              <svg
                                className="progressBar"
                                x="0px"
                                y="0px"
                                viewBox="0 0 80 80"
                              >
                                <path
                                  className="track"
                                  d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                                />
                                <path
                                  className="fill"
                                  d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                                  style={{
                                    strokeDashoffset:
                                      ((30 - timeLeft) / 30) * max
                                  }}
                                />
                                <text className="value" x="50%" y="55%">
                                  {timeLeft}
                                </text>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div className="col-8  col-md-4 inline-block Gameidcol">
                          Game ID:<span id="round-id">{roundId}</span>
                          <div
                            role="group"
                            aria-label="Second group"
                            className="btn-group btn-group-sm mr-2"
                          >
                            <button
                              type="button"
                              id="Alltab"
                              className={`tablink 
                                                    btn 
                                                    btn-primary 
                                                    ${
                                                      showResult
                                                        ? ""
                                                        : "bbactive"
                                                    }`}
                              onClick={() => hideResultDetail()}
                            >
                              Game
                            </button>
                            <button
                              type="button"
                              id="RESULTStab"
                              className={`tablink 
                                                btn 
                                                btn-primary 
                                                ${
                                                  showResult ? "bbactive" : ""
                                                }`}
                              onClick={() => showResultDetail()}
                            >
                              Results
                            </button>
                            <button
                              type="button"
                              className="tablink btn btn-primary "
                              data-toggle="modal"
                              data-target="#rulesPopup"
                              style={{ display: "inline-block" }}
                              onClick={() => setShowModal(true)}
                            >
                              Rules
                            </button>
                            {showModal && (
                              <div
                                class="modal fade  show"
                                id="rulesPopup"
                                tabindex="-1"
                                role="dialog"
                                data-keyboard="false"
                                data-backdrop="static"
                                style={{ display: "block" }}
                              >
                                <div
                                  class="modal-dialog modal-lg"
                                  role="document"
                                >
                                  <div
                                    class="modal-content modal-content-style"
                                    style={{
                                      backgroundColor: "#3C444B",
                                      color: "#AAAFB5",
                                      borderRadius: "6px"
                                    }}
                                  >
                                    <div
                                      class="modal-header"
                                      style={{
                                        borderBottom: "0px",
                                        padding: "5px",
                                        background: "#e0e0e0"
                                      }}
                                    >
                                      <div
                                        class="modal-title"
                                        id="exampleModalLabel"
                                        style={{
                                          fontSize: "20px",
                                          color: "rgba(0,0,0,.87)",
                                          margin: "5px 0px 0px 10px"
                                        }}
                                      >
                                        <b>Market Rules</b>
                                      </div>
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        style={{
                                          color: "white",
                                          margin: "-0.5rem -0.7rem -1rem auto"
                                        }}
                                      >
                                        <span
                                          aria-hidden="true"
                                          style={{
                                            color: "#000",
                                            opacity: "0.8"
                                          }}
                                          onClick={closeButton}
                                        >
                                          ×
                                        </span>
                                      </button>
                                    </div>
                                    <div
                                      class="modal-body"
                                      style={{
                                        marginTop: "0px",
                                        background: "#fff"
                                      }}
                                    >
                                      <div
                                        style={{
                                          background: "#fff",
                                          padding: "10px",
                                          borderRadius: "10px"
                                        }}
                                      >
                                        <div class="row">
                                          <div
                                            class="col-lg-12"
                                            style={{ color: "rgba(0,0,0,.87)" }}
                                          >
                                            <div
                                              id="market-rules-text"
                                              class="modal-body"
                                            >
                                              <div class="rules-component">
                                                <div
                                                  class="text-block-renderer-component"
                                                  style={{ textAlign: "left" }}
                                                >
                                                  <div class="section">
                                                    <h2
                                                      class="section-title"
                                                      style={{
                                                        fontWeight: "500"
                                                      }}
                                                    >
                                                      <span class="i18n">
                                                        Any number of winners
                                                      </span>
                                                    </h2>
                                                    <div class="section-content">
                                                      {/*<p class="paragraph"><span class="i18n bold">Total matched so far: </span>$261</p>*/}
                                                      <p class="paragraph">
                                                        <span class="i18n bold">
                                                          Commission on this
                                                          market:{" "}
                                                        </span>
                                                        1%
                                                      </p>
                                                    </div>
                                                  </div>
                                                  <div class="section">
                                                    <h2 class="section-title">
                                                      <span class="i18n">
                                                        BetPro Exchange
                                                        Blackjack
                                                      </span>
                                                    </h2>
                                                    <div class="section-content">
                                                      <h3 class="section-highlight">
                                                        <span class="i18n">
                                                          House Rules
                                                        </span>
                                                      </h3>
                                                      <p class="paragraph"></p>
                                                      <ul>
                                                        <li>
                                                          <span class="i18n">
                                                            Infinite Deck
                                                          </span>
                                                        </li>
                                                        <li>
                                                          <span class="i18n">
                                                            No Splitting /
                                                            Doubling or
                                                            Surrender
                                                          </span>
                                                        </li>
                                                        <li>
                                                          <span class="i18n">
                                                            Dealer sits on soft
                                                            17
                                                          </span>
                                                        </li>
                                                        <li>
                                                          <span class="i18n">
                                                            Hand rankings
                                                          </span>
                                                        </li>
                                                        <ul>
                                                          <li>
                                                            <span class="i18n">
                                                              Five Card Charlie
                                                            </span>
                                                          </li>
                                                          <li>
                                                            <span class="i18n">
                                                              Blackjack
                                                            </span>
                                                          </li>
                                                          <li>
                                                            <span class="i18n">
                                                              Highest points
                                                              value
                                                            </span>
                                                          </li>
                                                        </ul>
                                                        <li>
                                                          <span class="i18n text">
                                                            Customised{" "}
                                                            <a
                                                              href="https://support.betfair.com/app/answers/detail/a_id/249/"
                                                              target="_blank"
                                                              class="rules-link"
                                                            >
                                                              Player Logic
                                                            </a>
                                                          </span>
                                                        </li>
                                                      </ul>
                                                      <p></p>
                                                    </div>
                                                    <div class="section-content">
                                                      <h3 class="section-highlight">
                                                        <span class="i18n">
                                                          Exotic Selections
                                                        </span>
                                                      </h3>
                                                      <p class="paragraph">
                                                        <span class="i18n text">
                                                          There are 4 additional
                                                          betting selections
                                                          within Exchange
                                                          Blackjack for customer
                                                          to bet upon. They are:
                                                        </span>
                                                      </p>
                                                      <p class="paragraph"></p>
                                                      <ol>
                                                        <li>
                                                          <span class="i18n">
                                                            Dealer wins or ties
                                                            with all 4 player
                                                            hands.
                                                          </span>
                                                        </li>
                                                        <li>
                                                          <span class="i18n">
                                                            One of more of the 5
                                                            hands gets a "5 Card
                                                            Charlie".
                                                          </span>
                                                        </li>
                                                        <li>
                                                          <span class="i18n">
                                                            All Cards are unique
                                                            in respect of both
                                                            suit and value (e.g.
                                                            fails if the 3 of
                                                            clubs appears
                                                            twice).
                                                          </span>
                                                        </li>
                                                        <li>
                                                          <span class="i18n">
                                                            Only one hand on the
                                                            table has a points
                                                            value of exactly 21
                                                            pts.
                                                          </span>
                                                        </li>
                                                      </ol>
                                                      <p></p>
                                                    </div>
                                                    <div class="section-content">
                                                      <h3 class="section-highlight">
                                                        <span class="i18n">
                                                          Early Settlement
                                                        </span>
                                                      </h3>
                                                      <p class="paragraph">
                                                        <span class="i18n text">
                                                          Where the outcome of
                                                          all players hands is
                                                          known prior to the
                                                          normal end of game
                                                          play, (e.g. when all
                                                          players hands are
                                                          bust), then the game
                                                          will be halted, all
                                                          bets will be settled
                                                          and a new game
                                                          commenced. Click here
                                                          for more information
                                                          on{" "}
                                                          <a
                                                            href="https://support.betfair.com/app/answers/list/c/484/"
                                                            target="_blank"
                                                            class="rules-link"
                                                          >
                                                            Early Settlement
                                                          </a>
                                                          .
                                                        </span>
                                                      </p>
                                                    </div>
                                                    <div class="section-content">
                                                      <h3 class="section-highlight">
                                                        <span class="i18n">
                                                          Game Flow
                                                        </span>
                                                      </h3>
                                                      <p class="paragraph">
                                                        <span class="i18n text">
                                                          This game is based on
                                                          the casino game of
                                                          Blackjack.
                                                        </span>
                                                      </p>
                                                      <p class="paragraph">
                                                        <span class="i18n text">
                                                          The game begins with
                                                          10 cards dealt face
                                                          down. 8 of the 10
                                                          cards are paired to
                                                          form 4 separate
                                                          "player" hands (Player
                                                          1, Player 2, Player 3
                                                          and Player 4). The
                                                          remaining cards are
                                                          for the "Dealer" hand.
                                                        </span>
                                                      </p>
                                                      <p class="paragraph">
                                                        <span class="i18n text">
                                                          The first round of
                                                          betting occurs with no
                                                          cards face up.
                                                          Customers may place
                                                          bets on any individual
                                                          player to beat the
                                                          dealer or on any of
                                                          the four{" "}
                                                          <a
                                                            href="https://support.betfair.com/app/answers/list/c/484/"
                                                            target="_blank"
                                                            class="rules-link"
                                                          >
                                                            'exotic' selections
                                                          </a>
                                                          . Bets can be placed
                                                          to back or lay each
                                                          player or exotic
                                                          selection.
                                                        </span>
                                                      </p>
                                                      <p class="paragraph">
                                                        <span class="i18n text">
                                                          At the end of the
                                                          first round of
                                                          betting, all player
                                                          cards are turned over
                                                          along with the first
                                                          of the dealer's cards.
                                                          There is then another
                                                          round of betting.
                                                        </span>
                                                      </p>
                                                      <p class="paragraph">
                                                        <span class="i18n text">
                                                          After the second round
                                                          of betting the players
                                                          hands draw further
                                                          cards on the basis of
                                                          the defined{" "}
                                                          <a
                                                            href="https://support.betfair.com/app/answers/detail/a_id/249/"
                                                            target="_blank"
                                                            class="rules-link"
                                                          >
                                                            players logic table
                                                          </a>
                                                          . If a hand is bust
                                                          then it is suspended
                                                          from further betting
                                                          and all bets are
                                                          immediately settled.
                                                          The third round of
                                                          betting now begins
                                                          (unless all players
                                                          have bust - If all
                                                          players have bust the
                                                          game finishes without
                                                          the dealer taking a
                                                          second card).
                                                        </span>
                                                      </p>
                                                      <p class="paragraph">
                                                        <span class="i18n text">
                                                          After the third round
                                                          of betting the second
                                                          of the dealer's cards
                                                          is turned over. The
                                                          Dealer will stand if
                                                          he has soft 17 or
                                                          greater (soft refers
                                                          to when an Ace is
                                                          being counted as 11
                                                          points to make up the
                                                          points total) up to a
                                                          maximum of 5 cards. If
                                                          the dealer stands or
                                                          is bust then the game
                                                          is over and all bets
                                                          are immediately
                                                          settled. If not then
                                                          betting continues
                                                          until the dealer
                                                          stands or all of the
                                                          hands have been
                                                          resolved (i.e. it is
                                                          unknown whether they
                                                          will win, lose or
                                                          tie). For example, if
                                                          prior to the Dealer
                                                          taking a third card, 3
                                                          players have busted
                                                          and 1 player has a
                                                          Blackjack and the
                                                          Dealer cannot possibly
                                                          get a 5 card Charlie
                                                          because they have 15
                                                          or 16, then the dealer
                                                          cannot possibly win,
                                                          the player will be
                                                          settled as a winner
                                                          and the game finishes
                                                          without the Dealer
                                                          taking a further card.
                                                          Please see the{" "}
                                                          <a
                                                            href="https://support.betfair.com/app/answers/list/c/484/"
                                                            target="_blank"
                                                            class="rules-link"
                                                          >
                                                            help
                                                          </a>{" "}
                                                          section for more
                                                          information about
                                                          Exchange Blackjack.
                                                        </span>
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </center>
                    </div>
                  </div>
                  <div
                    id="AlltabData"
                    className="tabcontent"
                    style={{ display: showResult ? "none" : "contents" }}
                  >
                    <div className="left-content">
                      <div className="cards-layout blackjack">
                        <div>
                          <div className="dealer">
                            <div className="player-item">
                              <span className="name">Dealer</span>
                              <div className="player-card">
                                <div
                                  id="BFBCardHandView"
                                  className="BFBCardHandViewDealer"
                                >
                                  <div
                                    id="cards_desc"
                                    className="BFBCardFanView"
                                  >
                                    {cardsDesc &&
                                      cardsDesc.length > 0 &&
                                      cardsDesc.map((card, index) => {
                                        const cardImage = getCardImage(card);
                                        const cardClass = `card${index + 1}in5`;
                                        return (
                                          <div
                                            key={index}
                                            id="BFBCardView"
                                            className={cardClass}
                                          >
                                            <img
                                              id="RSMImageView"
                                              src={cardImage}
                                              alt={`Card ${card}`}
                                              className="RSMImageView"
                                            />
                                          </div>
                                        );
                                      })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="player">
                            <div className="player-item">
                              <span className="name">Hand 1</span>
                              <div
                                className="player-card  stood"
                                style={{
                                  padding: "unset",
                                  width: "auto",
                                  height: "auto"
                                }}
                              >
                                <div
                                  id="BFBCardHandView"
                                  className="BFBCardHandView"
                                >
                                  <div
                                    id="rnr1_desc"
                                    className="BFBCardFanView"
                                  >
                                    {cardsDesc1 &&
                                      cardsDesc1.length > 0 &&
                                      cardsDesc1.map((card, index) => {
                                        const cardImage = getCardImage(card);
                                        const cardClass = `card${index + 1}in4`;
                                        return (
                                          <div
                                            key={index}
                                            id="BFBCardView"
                                            className={cardClass}
                                          >
                                            <img
                                              id="RSMImageView"
                                              src={cardImage}
                                              alt={`Card ${card}`}
                                              className="RSMImageView"
                                            />
                                          </div>
                                        );
                                      })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="player">
                            <div className="player-item">
                              <span className="name">Hand 2</span>
                              <div
                                className="player-card  stood"
                                style={{
                                  padding: "unset",
                                  width: "auto",
                                  height: "auto"
                                }}
                              >
                                <div
                                  id="BFBCardHandView"
                                  className="BFBCardHandView"
                                >
                                  <div
                                    id="rnr2_desc"
                                    className="BFBCardFanView"
                                  >
                                    {cardsDesc2 &&
                                      cardsDesc2.length > 0 &&
                                      cardsDesc2.map((card, index) => {
                                        const cardImage = getCardImage(card);
                                        const cardClass = `card${index + 1}in4`;
                                        return (
                                          <div
                                            key={index}
                                            id="BFBCardView"
                                            className={cardClass}
                                          >
                                            <img
                                              id="RSMImageView"
                                              src={cardImage}
                                              alt={`Card ${card}`}
                                              className="RSMImageView"
                                            />
                                          </div>
                                        );
                                      })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="player">
                            <div className="player-item">
                              <span className="name">Hand 3</span>
                              <div
                                className="player-card  stood"
                                style={{
                                  padding: "unset",
                                  width: "auto",
                                  height: "auto"
                                }}
                              >
                                <div
                                  id="BFBCardHandView"
                                  className="BFBCardHandView"
                                >
                                  <div
                                    id="rnr3_desc"
                                    className="BFBCardFanView"
                                  >
                                    {cardsDesc3 &&
                                      cardsDesc3.length > 0 &&
                                      cardsDesc3.map((card, index) => {
                                        const cardImage = getCardImage(card);
                                        const cardClass = `card${index + 1}in4`;
                                        return (
                                          <div
                                            key={index}
                                            id="BFBCardView"
                                            className={cardClass}
                                          >
                                            <img
                                              id="RSMImageView"
                                              src={cardImage}
                                              alt={`Card ${card}`}
                                              className="RSMImageView"
                                            />
                                          </div>
                                        );
                                      })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="player">
                            <div className="player-item">
                              <span className="name">Hand 4</span>
                              <div
                                className="player-card  stood"
                                style={{
                                  padding: "unset",
                                  width: "auto",
                                  height: "auto"
                                }}
                              >
                                <div
                                  id="BFBCardHandView"
                                  className="BFBCardHandView"
                                >
                                  <div
                                    id="rnr4_desc"
                                    className="BFBCardFanView"
                                  >
                                    {cardsDesc4 &&
                                      cardsDesc4.length > 0 &&
                                      cardsDesc4.map((card, index) => {
                                        const cardImage = getCardImage(card);
                                        const cardClass = `card${index + 1}in4`;
                                        return (
                                          <div
                                            key={index}
                                            id="BFBCardView"
                                            className={cardClass}
                                          >
                                            <img
                                              id="RSMImageView"
                                              src={cardImage}
                                              alt={`Card ${card}`}
                                              className="RSMImageView"
                                            />
                                          </div>
                                        );
                                      })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <center>
                        <div
                          className="progress"
                          style={{
                            height: "3px",
                            maxWidth: "50%",
                            marginBottom: "8px"
                          }}
                        >
                          <div
                            id="Exgamesprogress"
                            role="progressbar"
                            aria-valuenow="0"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            className="progress-bar bg-danger"
                            style={{ width: `${time_percentage}%` }}
                            sid="roundProgressWidth"
                          ></div>
                        </div>
                      </center>
                      <div className="section-blur">
                        <div className="market-titlebar">
                          <p className="market-name"></p>
                          <div className="market-overarround">
                            <span></span>
                            <strong>Back</strong>
                          </div>
                          <div className="market-overarround market-overarround-lay">
                            <strong>Lay</strong>
                          </div>
                        </div>
                        <div className="market-runners">
                          <div className="runner-runner" id="b1status">
                            <h3
                              className={`runner-name ${
                                rnr1_status == "WINNER" ? "sussesBg" : ""
                              }`}
                            >
                              <div className="runner-info">
                                <span className="clippable runner-display-name">
                                  <h4
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-html="true"
                                    className="clippable-spacer"
                                  >
                                    Player 1
                                  </h4>
                                </span>
                              </div>
                              <div className="runner-position">
                                <span>
                                  <span className="">
                                    <strong id="bstatus1">
                                      {books.bookB1 !== "" ? (
                                        <span>
                                          {Number(books.bookB1) > 0 ? (
                                            <font color="green">
                                              {books.bookB1}
                                            </font>
                                          ) : (
                                            <font color="red">
                                              {books.bookB1}
                                            </font>
                                          )}
                                          <font style={{ color: "red" }}>
                                            {" "}
                                            /{" "}
                                          </font>
                                          <font style={{ color: "red" }}>
                                            {books.bookL1}
                                          </font>
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </strong>
                                  </span>
                                </span>
                              </div>
                            </h3>

                            <a
                              className="price-price price-back rnr1_status span1details"
                              id="runner1b3span"
                              data-teamname="Player 1"
                              data-bettype="b"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Player 1",
                                  "3",
                                  runner1b3
                                )
                              }
                            >
                              <span className="price-odd" id="runner1b3">
                                {runner1b3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner1b3_matched"
                              >
                                {runner1b3_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back rnr1_status span1details"
                              id="runner1b2span"
                              data-teamname="Player 1"
                              data-bettype="b"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Player 1",
                                  "2",
                                  runner1b2
                                )
                              }
                            >
                              <span className="price-odd" id="runner1b2">
                                {runner1b2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner1b2_matched"
                              >
                                {runner1b2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back mb-show rnr1_status span1details"
                              id="runner1b1span"
                              data-teamname="Player 1"
                              data-bettype="b"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Player 1",
                                  "1",
                                  runner1b1
                                )
                              }
                            >
                              <span className="price-odd" id="runner1b1">
                                {runner1b1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner1b1_matched"
                              >
                                {runner1b1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay mb-show rnr1_status span1details"
                              id="runner1l1span"
                              data-teamname="Player 1"
                              data-bettype="l"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Player 1",
                                  "1",
                                  runner1l1
                                )
                              }
                            >
                              <span className="price-odd" id="runner1l1">
                                {runner1l1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner1l1_matched"
                              >
                                {runner1l1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr1_status span1details"
                              id="runner1l2span"
                              data-teamname="Player 1"
                              data-bettype="l"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Player 1",
                                  "2",
                                  runner1l2
                                )
                              }
                            >
                              <span className="price-odd" id="runner1l2">
                                {runner1l2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner1l2_matched"
                              >
                                {runner1l2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr1_status span1details"
                              id="runner1l3span"
                              data-teamname="Player 1"
                              data-bettype="l"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Player 1",
                                  "3",
                                  runner1l3
                                )
                              }
                            >
                              <span className="price-odd" id="runner1l3">
                                {runner1l3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner1l3_matched"
                              >
                                {runner1l3_matched}
                              </span>
                            </a>
                            <div
                              className="runner-disabled suspendCls  suspended-overlap"
                              id="rnr1_status"
                              style={{
                                display:
                                  suspend1 != 0 ||
                                  rnr1_status != "IN_PLAY" ||
                                  evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                    ? "block"
                                    : "none"
                              }}
                            >
                              {rnr1_status}
                            </div>
                          </div>
                        </div>
                        <div className="market-runners">
                          <div className="runner-runner" id="b2status">
                            <h3
                              className={`runner-name ${
                                rnr2_status == "WINNER" ? "sussesBg" : ""
                              }`}
                            >
                              <div className="runner-info">
                                <span className="clippable runner-display-name">
                                  <h4
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-html="true"
                                    className="clippable-spacer"
                                  >
                                    Player 2
                                  </h4>
                                </span>
                              </div>
                              <div className="runner-position">
                                <span>
                                  <span className="">
                                    <strong id="bstatus2">
                                      {books.bookB2 !== "" ? (
                                        <span>
                                          {Number(books.bookB2) > 0 ? (
                                            <font color="green">
                                              {books.bookB2}
                                            </font>
                                          ) : (
                                            <font color="red">
                                              {books.bookB2}
                                            </font>
                                          )}
                                          <font style={{ color: "red" }}>
                                            {" "}
                                            /{" "}
                                          </font>
                                          <font style={{ color: "red" }}>
                                            {books.bookL2}
                                          </font>
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </strong>
                                  </span>
                                </span>
                              </div>
                            </h3>

                            <a
                              className="price-price price-back rnr2_status span1details"
                              id="runner2b3span"
                              data-teamname="Player 2"
                              data-bettype="b"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Player 2",
                                  "3",
                                  runner2b3
                                )
                              }
                            >
                              <span className="price-odd" id="runner2b3">
                                {runner2b3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner2b3_matched"
                              >
                                {runner2b3_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back rnr2_status span1details"
                              id="runner2b2span"
                              data-teamname="Player 2"
                              data-bettype="b"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Player 2",
                                  "2",
                                  runner2b2
                                )
                              }
                            >
                              <span className="price-odd" id="runner2b2">
                                {runner2b2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner2b2_matched"
                              >
                                {runner2b2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back mb-show rnr2_status span1details"
                              id="runner2b1span"
                              data-teamname="Player 2"
                              data-bettype="b"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Player 2",
                                  "1",
                                  runner2b1
                                )
                              }
                            >
                              <span className="price-odd" id="runner2b1">
                                {runner2b1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner2b1_matched"
                              >
                                {runner2b1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay mb-show rnr2_status span1details"
                              id="runner2l1span"
                              data-teamname="Player 2"
                              data-bettype="l"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Player 2",
                                  "1",
                                  runner2l1
                                )
                              }
                            >
                              <span className="price-odd" id="runner2l1">
                                {runner2l1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner2l1_matched"
                              >
                                {runner2l1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr2_status span1details"
                              id="runner2l2span"
                              data-teamname="Player 2"
                              data-bettype="l"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Player 2",
                                  "2",
                                  runner2l2
                                )
                              }
                            >
                              <span className="price-odd" id="runner2l2">
                                {runner2l2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner2l2_matched"
                              >
                                {runner2l2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr2_status span1details"
                              id="runner2l3span"
                              data-teamname="Player 2"
                              data-bettype="l"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Player 2",
                                  "3",
                                  runner2l3
                                )
                              }
                            >
                              <span className="price-odd" id="runner2l3">
                                {runner2l3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner2l3_matched"
                              >
                                {runner2l3_matched}
                              </span>
                            </a>
                            <div
                              className="runner-disabled suspendCls  suspended-overlap"
                              id="rnr2_status"
                              style={{
                                display:
                                  suspend2 != 0 ||
                                  rnr2_status != "IN_PLAY" ||
                                  evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                    ? "block"
                                    : "none"
                              }}
                            >
                              {rnr2_status}
                            </div>
                          </div>
                        </div>
                        <div className="market-runners">
                          <div className="runner-runner" id="b3status">
                            <h3
                              className={`runner-name ${
                                rnr3_status == "WINNER" ? "sussesBg" : ""
                              }`}
                            >
                              <div className="runner-info">
                                <span className="clippable runner-display-name">
                                  <h4
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-html="true"
                                    className="clippable-spacer"
                                  >
                                    Player 3
                                  </h4>
                                </span>
                              </div>
                              <div className="runner-position">
                                <span>
                                  <span className="">
                                    <strong id="bstatus3">
                                      {books.bookB3 !== "" ? (
                                        <span>
                                          {Number(books.bookB3) > 0 ? (
                                            <font color="green">
                                              {books.bookB3}
                                            </font>
                                          ) : (
                                            <font color="red">
                                              {books.bookB3}
                                            </font>
                                          )}
                                          <font style={{ color: "red" }}>
                                            {" "}
                                            /{" "}
                                          </font>
                                          <font style={{ color: "red" }}>
                                            {books.bookL3}
                                          </font>
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </strong>
                                  </span>
                                </span>
                              </div>
                            </h3>

                            <a
                              className="price-price price-back rnr3_status span1details"
                              id="runner3b3span"
                              data-teamname="Player 3"
                              data-bettype="b"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Player 3",
                                  "3",
                                  runner3b3
                                )
                              }
                            >
                              <span className="price-odd" id="runner3b3">
                                {runner3b3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner3b3_matched"
                              >
                                {runner3b3_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back rnr3_status span1details"
                              id="runner3b2span"
                              data-teamname="Player 3"
                              data-bettype="b"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Player 3",
                                  "2",
                                  runner3b2
                                )
                              }
                            >
                              <span className="price-odd" id="runner3b2">
                                {runner3b2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner3b2_matched"
                              >
                                {runner3b2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back mb-show rnr3_status span1details"
                              id="runner3b1span"
                              data-teamname="Player 3"
                              data-bettype="b"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Player 3",
                                  "1",
                                  runner3b1
                                )
                              }
                            >
                              <span className="price-odd" id="runner3b1">
                                {runner3b1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner3b1_matched"
                              >
                                {runner3b1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay mb-show rnr3_status span1details"
                              id="runner3l1span"
                              data-teamname="Player 3"
                              data-bettype="l"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Player 3",
                                  "1",
                                  runner3l1
                                )
                              }
                            >
                              <span className="price-odd" id="runner3l1">
                                {runner3l1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner3l1_matched"
                              >
                                {runner3l1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr3_status span1details"
                              id="runner3l2span"
                              data-teamname="Player 3"
                              data-bettype="l"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Player 3",
                                  "2",
                                  runner3l2
                                )
                              }
                            >
                              <span className="price-odd" id="runner3l2">
                                {runner3l2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner3l2_matched"
                              >
                                {runner3l2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr3_status span1details"
                              id="runner3l3span"
                              data-teamname="Player 3"
                              data-bettype="l"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Player 3",
                                  "3",
                                  runner3l3
                                )
                              }
                            >
                              <span className="price-odd" id="runner3l3">
                                {runner3l3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner3l3_matched"
                              >
                                {runner3l3_matched}
                              </span>
                            </a>
                            <div
                              className="runner-disabled suspendCls  suspended-overlap"
                              id="rnr3_status"
                              style={{
                                display:
                                  suspend3 != 0 ||
                                  rnr3_status != "IN_PLAY" ||
                                  evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                    ? "block"
                                    : "none"
                              }}
                            >
                              {rnr3_status}
                            </div>
                          </div>
                        </div>
                        <div className="market-runners">
                          <div className="runner-runner" id="b4status">
                            <h3
                              className={`runner-name ${
                                rnr4_status == "WINNER" ? "sussesBg" : ""
                              }`}
                            >
                              <div className="runner-info">
                                <span className="clippable runner-display-name">
                                  <h4
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-html="true"
                                    className="clippable-spacer"
                                  >
                                    Player 4
                                  </h4>
                                </span>
                              </div>
                              <div className="runner-position">
                                <span>
                                  <span className="">
                                    <strong id="bstatus4">
                                      {books.bookB4 !== "" ? (
                                        <span>
                                          {Number(books.bookB4) > 0 ? (
                                            <font color="green">
                                              {books.bookB4}
                                            </font>
                                          ) : (
                                            <font color="red">
                                              {books.bookB4}
                                            </font>
                                          )}
                                          <font style={{ color: "red" }}>
                                            {" "}
                                            /{" "}
                                          </font>
                                          <font style={{ color: "red" }}>
                                            {books.bookL4}
                                          </font>
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </strong>
                                  </span>
                                </span>
                              </div>
                            </h3>

                            <a
                              className="price-price price-back rnr4_status span1details"
                              id="runner4b3span"
                              data-teamname="Player 4"
                              data-bettype="b"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Player 4",
                                  "3",
                                  runner4b3
                                )
                              }
                            >
                              <span className="price-odd" id="runner4b3">
                                {runner4b3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner4b3_matched"
                              >
                                {runner4b3_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back rnr4_status span1details"
                              id="runner4b2span"
                              data-teamname="Player 4"
                              data-bettype="b"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Player 4",
                                  "2",
                                  runner4b2
                                )
                              }
                            >
                              <span className="price-odd" id="runner4b2">
                                {runner4b2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner4b2_matched"
                              >
                                {runner4b2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back mb-show rnr4_status span1details"
                              id="runner4b1span"
                              data-teamname="Player 4"
                              data-bettype="b"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Player 4",
                                  "1",
                                  runner4b1
                                )
                              }
                            >
                              <span className="price-odd" id="runner4b1">
                                {runner4b1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner4b1_matched"
                              >
                                {runner4b1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay mb-show rnr4_status span1details"
                              id="runner4l1span"
                              data-teamname="Player 4"
                              data-bettype="l"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Player 4",
                                  "1",
                                  runner4l1
                                )
                              }
                            >
                              <span className="price-odd" id="runner4l1">
                                {runner4l1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner4l1_matched"
                              >
                                {runner4l1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr4_status span1details"
                              id="runner4l2span"
                              data-teamname="Player 4"
                              data-bettype="l"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Player 4",
                                  "2",
                                  runner4l2
                                )
                              }
                            >
                              <span className="price-odd" id="runner4l2">
                                {runner4l2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner4l2_matched"
                              >
                                {runner4l2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr4_status span1details"
                              id="runner4l3span"
                              data-teamname="Player 4"
                              data-bettype="l"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Player 4",
                                  "3",
                                  runner4l3
                                )
                              }
                            >
                              <span className="price-odd" id="runner4l3">
                                {runner4l3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner4l3_matched"
                              >
                                {runner4l3_matched}
                              </span>
                            </a>
                            <div
                              className="runner-disabled suspendCls  suspended-overlap"
                              id="rnr4_status"
                              style={{
                                display:
                                  suspend4 != 0 ||
                                  rnr4_status != "IN_PLAY" ||
                                  evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                    ? "block"
                                    : "none"
                              }}
                            >
                              {rnr4_status}
                            </div>
                          </div>
                        </div>

                        <div className="market-runners">
                          <div className="runner-runner" id="b5status">
                            <h3
                              className={`runner-name ${
                                rnr5_status == "WINNER" ? "sussesBg" : ""
                              }`}
                            >
                              <div className="runner-info">
                                <span className="clippable runner-display-name">
                                  <h4
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-html="true"
                                    className="clippable-spacer"
                                  >
                                    Dealer wins or ties all
                                  </h4>
                                </span>
                              </div>
                              <div className="runner-position">
                                <span>
                                  <span className="">
                                    <strong id="bstatus5">
                                      {books.bookB5 !== "" ? (
                                        <span>
                                          {Number(books.bookB5) > 0 ? (
                                            <font color="green">
                                              {books.bookB5}
                                            </font>
                                          ) : (
                                            <font color="red">
                                              {books.bookB5}
                                            </font>
                                          )}
                                          <font style={{ color: "red" }}>
                                            {" "}
                                            /{" "}
                                          </font>
                                          <font style={{ color: "red" }}>
                                            {books.bookL5}
                                          </font>
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </strong>
                                  </span>
                                </span>
                              </div>
                            </h3>

                            <a
                              className="price-price price-back rnr5_status span1details"
                              id="runner5b3span"
                              data-teamname="Dealer wins or ties all"
                              data-bettype="b"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Dealer wins or ties all",
                                  "3",
                                  runner5b3
                                )
                              }
                            >
                              <span className="price-odd" id="runner5b3">
                                {runner5b3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner5b3_matched"
                              >
                                {runner5b3_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back rnr5_status span1details"
                              id="runner5b2span"
                              data-teamname="Dealer wins or ties all"
                              data-bettype="b"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Dealer wins or ties all",
                                  "2",
                                  runner5b2
                                )
                              }
                            >
                              <span className="price-odd" id="runner5b2">
                                {runner5b2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner5b2_matched"
                              >
                                {runner5b2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back mb-show rnr5_status span1details"
                              id="runner5b1span"
                              data-teamname="Dealer wins or ties all"
                              data-bettype="b"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Dealer wins or ties all",
                                  "1",
                                  runner5b1
                                )
                              }
                            >
                              <span className="price-odd" id="runner5b1">
                                {runner5b1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner5b1_matched"
                              >
                                {runner5b1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay mb-show rnr5_status span1details"
                              id="runner5l1span"
                              data-teamname="Dealer wins or ties all"
                              data-bettype="l"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Dealer wins or ties all",
                                  "1",
                                  runner5l1
                                )
                              }
                            >
                              <span className="price-odd" id="runner5l1">
                                {runner5l1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner5l1_matched"
                              >
                                {runner5l1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr5_status span1details"
                              id="runner5l2span"
                              data-teamname="Dealer wins or ties all"
                              data-bettype="l"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Dealer wins or ties all",
                                  "2",
                                  runner5l2
                                )
                              }
                            >
                              <span className="price-odd" id="runner5l2">
                                {runner5l2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner5l2_matched"
                              >
                                {runner5l2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr5_status span1details"
                              id="runner5l3span"
                              data-teamname="Dealer wins or ties all"
                              data-bettype="l"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Dealer wins or ties all",
                                  "3",
                                  runner5l3
                                )
                              }
                            >
                              <span className="price-odd" id="runner5l3">
                                {runner5l3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner5l3_matched"
                              >
                                {runner5l3_matched}
                              </span>
                            </a>
                            <div
                              className="runner-disabled suspendCls  suspended-overlap"
                              id="rnr5_status"
                              style={{
                                display:
                                  suspend5 != 0 ||
                                  rnr5_status != "IN_PLAY" ||
                                  evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                    ? "block"
                                    : "none"
                              }}
                            >
                              {rnr5_status}
                            </div>
                          </div>
                        </div>

                        <div className="market-runners">
                          <div className="runner-runner" id="b6status">
                            <h3
                              className={`runner-name ${
                                rnr6_status == "WINNER" ? "sussesBg" : ""
                              }`}
                            >
                              <div className="runner-info">
                                <span className="clippable runner-display-name">
                                  <h4
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-html="true"
                                    className="clippable-spacer"
                                  >
                                    One or more has 5 cards
                                  </h4>
                                </span>
                              </div>
                              <div className="runner-position">
                                <span>
                                  <span className="">
                                    <strong id="bstatus6">
                                      {books.bookB6 !== "" ? (
                                        <span>
                                          {Number(books.bookB6) > 0 ? (
                                            <font color="green">
                                              {books.bookB6}
                                            </font>
                                          ) : (
                                            <font color="red">
                                              {books.bookB6}
                                            </font>
                                          )}
                                          <font style={{ color: "red" }}>
                                            {" "}
                                            /{" "}
                                          </font>
                                          <font style={{ color: "red" }}>
                                            {books.bookL6}
                                          </font>
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </strong>
                                  </span>
                                </span>
                              </div>
                            </h3>

                            <a
                              className="price-price price-back rnr6_status span1details"
                              id="runner6b3span"
                              data-teamname="One or more has 5 cards"
                              data-bettype="b"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "One or more has 5 cards",
                                  "3",
                                  runner6b3
                                )
                              }
                            >
                              <span className="price-odd" id="runner6b3">
                                {runner6b3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner6b3_matched"
                              >
                                {runner6b3_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back rnr6_status span1details"
                              id="runner6b2span"
                              data-teamname="One or more has 5 cards"
                              data-bettype="b"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "One or more has 5 cards",
                                  "2",
                                  runner6b2
                                )
                              }
                            >
                              <span className="price-odd" id="runner6b2">
                                {runner6b2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner6b2_matched"
                              >
                                {runner6b2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back mb-show rnr6_status span1details"
                              id="runner6b1span"
                              data-teamname="One or more has 5 cards"
                              data-bettype="b"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "One or more has 5 cards",
                                  "1",
                                  runner6b1
                                )
                              }
                            >
                              <span className="price-odd" id="runner6b1">
                                {runner6b1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner6b1_matched"
                              >
                                {runner6b1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay mb-show rnr6_status span1details"
                              id="runner6l1span"
                              data-teamname="One or more has 5 cards"
                              data-bettype="l"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "One or more has 5 cards",
                                  "1",
                                  runner6l1
                                )
                              }
                            >
                              <span className="price-odd" id="runner6l1">
                                {runner6l1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner6l1_matched"
                              >
                                {runner6l1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr6_status span1details"
                              id="runner6l2span"
                              data-teamname="One or more has 5 cards"
                              data-bettype="l"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "One or more has 5 cards",
                                  "2",
                                  runner6l2
                                )
                              }
                            >
                              <span className="price-odd" id="runner6l2">
                                {runner6l2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner6l2_matched"
                              >
                                {runner6l2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr6_status span1details"
                              id="runner6l3span"
                              data-teamname="One or more has 5 cards"
                              data-bettype="l"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "One or more has 5 cards",
                                  "3",
                                  runner6b3
                                )
                              }
                            >
                              <span className="price-odd" id="runner6l3">
                                {runner6l3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner6l3_matched"
                              >
                                {runner6l3_matched}
                              </span>
                            </a>
                            <div
                              className="runner-disabled suspendCls  suspended-overlap"
                              id="rnr6_status"
                              style={{
                                display:
                                  suspend6 != 0 ||
                                  rnr6_status != "IN_PLAY" ||
                                  evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                    ? "block"
                                    : "none"
                              }}
                            >
                              {rnr6_status}
                            </div>
                          </div>
                        </div>

                        <div className="market-runners">
                          <div className="runner-runner" id="b7status">
                            <h3
                              className={`runner-name ${
                                rnr7_status == "WINNER" ? "sussesBg" : ""
                              }`}
                            >
                              <div className="runner-info">
                                <span className="clippable runner-display-name">
                                  <h4
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-html="true"
                                    className="clippable-spacer"
                                  >
                                    All cards unique
                                  </h4>
                                </span>
                              </div>
                              <div className="runner-position">
                                <span>
                                  <span className="">
                                    <strong id="bstatus7">
                                      {books.bookB7 !== "" ? (
                                        <span>
                                          {Number(books.bookB7) > 0 ? (
                                            <font color="green">
                                              {books.bookB7}
                                            </font>
                                          ) : (
                                            <font color="red">
                                              {books.bookB7}
                                            </font>
                                          )}
                                          <font style={{ color: "red" }}>
                                            {" "}
                                            /{" "}
                                          </font>
                                          <font style={{ color: "red" }}>
                                            {books.bookL7}
                                          </font>
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </strong>
                                  </span>
                                </span>
                              </div>
                            </h3>

                            <a
                              className="price-price price-back rnr7_status span1details"
                              id="runner7b3span"
                              data-teamname="All cards unique"
                              data-bettype="b"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "All cards unique",
                                  "3",
                                  runner7b3
                                )
                              }
                            >
                              <span className="price-odd" id="runner7b3">
                                {runner7b3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner7b3_matched"
                              >
                                {runner7b3_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back rnr7_status span1details"
                              id="runner7b2span"
                              data-teamname="All cards unique"
                              data-bettype="b"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "All cards unique",
                                  "2",
                                  runner7b2
                                )
                              }
                            >
                              <span className="price-odd" id="runner7b2">
                                {runner7b2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner7b2_matched"
                              >
                                {runner7b2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back mb-show rnr7_status span1details"
                              id="runner7b1span"
                              data-teamname="All cards unique"
                              data-bettype="b"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "All cards unique",
                                  "1",
                                  runner7b1
                                )
                              }
                            >
                              <span className="price-odd" id="runner7b1">
                                {runner7b1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner7b1_matched"
                              >
                                {runner7b1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay mb-show rnr7_status span1details"
                              id="runner7l1span"
                              data-teamname="All cards unique"
                              data-bettype="l"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "All cards unique",
                                  "1",
                                  runner7l1
                                )
                              }
                            >
                              <span className="price-odd" id="runner7l1">
                                {runner7l1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner7l1_matched"
                              >
                                {runner7l1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr7_status span1details"
                              id="runner7l2span"
                              data-teamname="All cards unique"
                              data-bettype="l"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "All cards unique",
                                  "2",
                                  runner7l2
                                )
                              }
                            >
                              <span className="price-odd" id="runner7l2">
                                {runner7l2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner7l2_matched"
                              >
                                {runner7l2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr7_status span1details"
                              id="runner7l3span"
                              data-teamname="All cards unique"
                              data-bettype="l"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "All cards unique",
                                  "3",
                                  runner7l3
                                )
                              }
                            >
                              <span className="price-odd" id="runner7l3">
                                {runner7l3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner7l3_matched"
                              >
                                {runner7l3_matched}
                              </span>
                            </a>
                            <div
                              className="runner-disabled suspendCls  suspended-overlap"
                              id="rnr7_status"
                              style={{
                                display:
                                  suspend7 != 0 ||
                                  rnr7_status != "IN_PLAY" ||
                                  evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                    ? "block"
                                    : "none"
                              }}
                            >
                              {rnr7_status}
                            </div>
                          </div>
                        </div>

                        <div className="market-runners">
                          <div className="runner-runner" id="b8status">
                            <h3
                              className={`runner-name ${
                                rnr8_status == "WINNER" ? "sussesBg" : ""
                              }`}
                            >
                              <div className="runner-info">
                                <span className="clippable runner-display-name">
                                  <h4
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-html="true"
                                    className="clippable-spacer"
                                  >
                                    Only one has 21pts
                                  </h4>
                                </span>
                              </div>
                              <div className="runner-position">
                                <span>
                                  <span className="">
                                    <strong id="bstatus8">
                                      {books.bookB8 !== "" ? (
                                        <span>
                                          {Number(books.bookB8) > 0 ? (
                                            <font color="green">
                                              {books.bookB8}
                                            </font>
                                          ) : (
                                            <font color="red">
                                              {books.bookB8}
                                            </font>
                                          )}
                                          <font style={{ color: "red" }}>
                                            {" "}
                                            /{" "}
                                          </font>
                                          <font style={{ color: "red" }}>
                                            {books.bookL8}
                                          </font>
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </strong>
                                  </span>
                                </span>
                              </div>
                            </h3>

                            <a
                              className="price-price price-back rnr8_status span1details"
                              id="runner8b3span"
                              data-teamname="Only one has 21pts"
                              data-bettype="b"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Only one has 21pts",
                                  "3",
                                  runner8b3
                                )
                              }
                            >
                              <span className="price-odd" id="runner8b3">
                                {runner8b3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner8b3_matched"
                              >
                                {runner8b3_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back rnr8_status span1details"
                              id="runner8b2span"
                              data-teamname="Only one has 21pts"
                              data-bettype="b"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Only one has 21pts",
                                  "2",
                                  runner8b2
                                )
                              }
                            >
                              <span className="price-odd" id="runner8b2">
                                {runner8b2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner8b2_matched"
                              >
                                {runner8b2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-back mb-show rnr8_status span1details"
                              id="runner8b1span"
                              data-teamname="Only one has 21pts"
                              data-bettype="b"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "b",
                                  "Only one has 21pts",
                                  "1",
                                  runner8b1
                                )
                              }
                            >
                              <span className="price-odd" id="runner8b1">
                                {runner8b1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner8b1_matched"
                              >
                                {runner8b1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay mb-show rnr8_status span1details"
                              id="runner8l1span"
                              data-teamname="Only one has 21pts"
                              data-bettype="l"
                              data-selectRnr="1"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Only one has 21pts",
                                  "1",
                                  runner8l1
                                )
                              }
                            >
                              <span className="price-odd" id="runner8l1">
                                {runner8l1}
                              </span>
                              <span
                                className="price-amount"
                                id="runner8l1_matched"
                              >
                                {runner8l1_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr8_status span1details"
                              id="runner8l2span"
                              data-teamname="Only one has 21pts"
                              data-bettype="l"
                              data-selectRnr="2"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Only one has 21pts",
                                  "2",
                                  runner8l2
                                )
                              }
                            >
                              <span className="price-odd" id="runner8l2">
                                {runner8l2}
                              </span>
                              <span
                                className="price-amount"
                                id="runner8l2_matched"
                              >
                                {runner8l2_matched}
                              </span>
                            </a>
                            <a
                              className="price-price price-lay rnr8_status span1details"
                              id="runner8l3span"
                              data-teamname="Only one has 21pts"
                              data-bettype="l"
                              data-selectRnr="3"
                              onClick={() =>
                                showBetfairBetSlip(
                                  "l",
                                  "Only one has 21pts",
                                  "3",
                                  runner8l3
                                )
                              }
                            >
                              <span className="price-odd" id="runner8l3">
                                {runner8l3}
                              </span>
                              <span
                                className="price-amount"
                                id="runner8l3_matched"
                              >
                                {runner8l3_matched}
                              </span>
                            </a>
                            <div
                              className="runner-disabled suspendCls  suspended-overlap"
                              id="rnr8_status"
                              style={{
                                display:
                                  suspend8 != 0 ||
                                  rnr8_status != "IN_PLAY" ||
                                  evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                    ? "block"
                                    : "none"
                              }}
                            >
                              {rnr8_status}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="ResultsData"
                    className="tabcontent"
                    style={{ display: showResult ? "contents" : "none" }}
                  >
                    {resultData &&
                      resultData.length > 0 &&
                      resultData.map((dataObj, index) => {
                        let win1 = dataObj.rnr1_status;
                        let win2 = dataObj.rnr2_status;
                        let win3 = dataObj.rnr3_status;
                        let win4 = dataObj.rnr4_status;

                        let bgCls1 = win1 == "WINNER" ? "bgwinner" : "bgLoser";
                        let bgCls2 = win2 == "WINNER" ? "bgwinner" : "bgLoser";
                        let bgCls3 = win3 == "WINNER" ? "bgwinner" : "bgLoser";
                        let bgCls4 = win4 == "WINNER" ? "bgwinner" : "bgLoser";

                        let tdCls1 = win1 == "WINNER" ? "TdResultsWin" : "";
                        let tdCls2 = win2 == "WINNER" ? "TdResultsWin" : "";
                        let tdCls3 = win3 == "WINNER" ? "TdResultsWin" : "";
                        let tdCls4 = win4 == "WINNER" ? "TdResultsWin" : "";

                        let cardsArr = dataObj.cards_desc.split(",");
                        let rnr1Arr = dataObj.rnr1_desc.split(",");
                        let rnr2Arr = dataObj.rnr2_desc.split(",");
                        let rnr3Arr = dataObj.rnr3_desc.split(",");
                        let rnr4Arr = dataObj.rnr4_desc.split(",");
                        return (
                          <div class="left-content">
                            <div
                              class="card"
                              style={{
                                border: "1px solid rgb(204, 204, 204)",
                                borderRadius: "8px",
                                padding: "10px",
                                boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 8px",
                                marginBottom: "5px",
                                background:
                                  "linear-gradient(rgb(15, 15, 15), rgb(251, 251, 251))",
                                color: "white"
                              }}
                            >
                              <div
                                class="card-header"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                  marginBottom: "5px",
                                  backgroundColor: "rgba(0, 0, 0, .03)"
                                }}
                              >
                                {dataObj.evt_od} - (<b>Round Id = </b>{" "}
                                {dataObj.evt_id})
                              </div>
                              <div class="card-body">
                                <div
                                  class="players-table"
                                  style={{ textAlign: "center", width: "100%" }}
                                >
                                  <table style={tableStyle}>
                                    <tbody>
                                      <tr style={rowFlexStyle}>
                                        <td
                                          style={communityTdResultsStyle}
                                          className="TdResults"
                                        >
                                          <div
                                            className="player-cards"
                                            style={playerCardsStyle}
                                          >
                                            <div
                                              className="player-name"
                                              style={playerNameStyle}
                                            >
                                              Community Cards
                                            </div>
                                            <div
                                              className="card-images"
                                              style={cardImagesStyle}
                                            >
                                              {cardsArr &&
                                                cardsArr.length > 0 &&
                                                cardsArr.map((card, index) => {
                                                  const cardImage =
                                                    getCardImage(card);
                                                  return (
                                                    <img
                                                      src={cardImage}
                                                      loading="lazy"
                                                      style={cardImgStyle}
                                                    />
                                                  );
                                                })}
                                            </div>
                                          </div>
                                        </td>
                                      </tr>

                                      <tr style={rowFlexStyle}>
                                        <td
                                          style={tdResultsStyle}
                                          className={`TdResults ${tdCls1}`}
                                        >
                                          <div
                                            className="player-cards"
                                            style={playerCardsStyle}
                                          >
                                            <div
                                              className="player-name"
                                              style={playerNameStyle}
                                            >
                                              Player 1
                                            </div>
                                            <div
                                              className="card-images"
                                              style={cardImagesStyle}
                                            >
                                              {rnr1Arr &&
                                                rnr1Arr.length > 0 &&
                                                rnr1Arr.map((card, index) => {
                                                  const cardImage =
                                                    getCardImage(card);
                                                  return (
                                                    <img
                                                      src={cardImage}
                                                      loading="lazy"
                                                      style={cardImgStyle}
                                                    />
                                                  );
                                                })}
                                            </div>
                                            <div
                                              className={`player-status ${bgCls1}`}
                                              style={playerStatusStyle}
                                            >
                                              {dataObj.rnr1_status}
                                            </div>
                                          </div>
                                        </td>

                                        <td
                                          style={tdResultsStyle}
                                          className={`TdResults ${tdCls2}`}
                                        >
                                          <div
                                            className="player-cards"
                                            style={playerCardsStyle}
                                          >
                                            <div
                                              className="player-name"
                                              style={playerNameStyle}
                                            >
                                              Player 2
                                            </div>
                                            <div
                                              className="card-images"
                                              style={cardImagesStyle}
                                            >
                                              {rnr2Arr &&
                                                rnr2Arr.length > 0 &&
                                                rnr2Arr.map((card, index) => {
                                                  const cardImage =
                                                    getCardImage(card);
                                                  return (
                                                    <img
                                                      src={cardImage}
                                                      loading="lazy"
                                                      style={cardImgStyle}
                                                    />
                                                  );
                                                })}
                                            </div>
                                            <div
                                              className={`player-status ${bgCls2}`}
                                              style={playerStatusStyle}
                                            >
                                              {dataObj.rnr2_status}
                                            </div>
                                          </div>
                                        </td>

                                        <td
                                          style={tdResultsStyle}
                                          className={`TdResults ${tdCls3}`}
                                        >
                                          <div
                                            className="player-cards"
                                            style={playerCardsStyle}
                                          >
                                            <div
                                              className="player-name"
                                              style={playerNameStyle}
                                            >
                                              Player 3
                                            </div>
                                            <div
                                              className="card-images"
                                              style={cardImagesStyle}
                                            >
                                              {rnr3Arr &&
                                                rnr3Arr.length > 0 &&
                                                rnr3Arr.map((card, index) => {
                                                  const cardImage =
                                                    getCardImage(card);
                                                  return (
                                                    <img
                                                      src={cardImage}
                                                      loading="lazy"
                                                      style={cardImgStyle}
                                                    />
                                                  );
                                                })}
                                            </div>
                                            <div
                                              className={`player-status ${bgCls3}`}
                                              style={playerStatusStyle}
                                            >
                                              {dataObj.rnr3_status}
                                            </div>
                                          </div>
                                        </td>

                                        <td
                                          style={tdResultsStyle}
                                          className={`TdResults ${tdCls4}`}
                                        >
                                          <div
                                            className="player-cards"
                                            style={playerCardsStyle}
                                          >
                                            <div
                                              className="player-name"
                                              style={playerNameStyle}
                                            >
                                              Player 4
                                            </div>
                                            <div
                                              className="card-images"
                                              style={cardImagesStyle}
                                            >
                                              {rnr4Arr &&
                                                rnr4Arr.length > 0 &&
                                                rnr4Arr.map((card, index) => {
                                                  const cardImage =
                                                    getCardImage(card);
                                                  return (
                                                    <img
                                                      src={cardImage}
                                                      loading="lazy"
                                                      style={cardImgStyle}
                                                    />
                                                  );
                                                })}
                                            </div>
                                            <div
                                              className={`player-status ${bgCls4}`}
                                              style={playerStatusStyle}
                                            >
                                              {dataObj.rnr4_status}
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="right-content">
                    <div>
                      <div className="table-box-body">
                        <div
                          id="betSlip"
                          className="bets"
                          style={{ display: "none" }}
                        >
                          <strong>
                            Bet Slip{" "}
                            <a
                              target="_blank"
                              href="/Customer/Profile"
                              className="button"
                              style={{ color: "white", float: "right" }}
                            >
                              Edit Bet Sizes
                            </a>
                          </strong>
                          <div className="betting-table">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Bet for</th>
                                  <th>Odds</th>
                                  <th>Stake</th>
                                  <th>Profit</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr className="back">
                                  <td></td>
                                  <td width="10%">
                                    <div className="quantity">
                                      <input type="text" id="bet-price" />
                                      <div className="quantity-nav">
                                        <div className="quantity-button quantity-up">
                                          <span className="fa fa-caret-up"></span>
                                        </div>
                                        <div className="quantity-button quantity-down">
                                          <span className="fa fa-caret-down"></span>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td width="10%">
                                    <div className="stake">
                                      <input type="text" id="bet-size" />
                                    </div>
                                  </td>
                                  <td> / -</td>
                                </tr>
                                <tr className="back">
                                  <td colspan="5">
                                    <table className="table">
                                      <tbody>
                                        <tr className="checknow">
                                          <td>
                                            <span
                                              data-amount="2000"
                                              className="points"
                                            >
                                              2,000
                                            </span>
                                          </td>
                                          <td>
                                            <span className="points">
                                              5,000
                                            </span>
                                          </td>
                                          <td>
                                            <span className="points">
                                              10,000
                                            </span>
                                          </td>
                                          <td>
                                            <span className="points">
                                              25,000
                                            </span>
                                          </td>
                                        </tr>
                                        <tr className="checknow">
                                          <td>
                                            <span className="points">
                                              + 1,000
                                            </span>
                                          </td>
                                          <td>
                                            <span className="points">
                                              + 5,000
                                            </span>
                                          </td>
                                          <td>
                                            <span className="points">
                                              + 10,000
                                            </span>
                                          </td>
                                          <td>
                                            <span className="points">
                                              + 25,000
                                            </span>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td>
                                            <button
                                              type="reset"
                                              className="align-left btn btn-danger"
                                            >
                                              <b>Close</b>
                                            </button>
                                          </td>
                                          <td>
                                            <button
                                              type="reset"
                                              className="align-left btn btn-warning"
                                            >
                                              <b>Clear</b>
                                            </button>
                                          </td>
                                          <td colspan="1"></td>
                                          <td>
                                            <div
                                              className="btn btn-primary ld-over"
                                              style={{ cursor: "pointer" }}
                                            >
                                              <b>Submit</b>
                                              <div className="ld ld-ball ld-flip"></div>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div
                          id="betSlipMobile"
                          tabindex="-1"
                          role="dialog"
                          aria-labelledby="fancyPosition"
                          aria-hidden="true"
                          className="modal fade"
                        >
                          <div
                            role="document"
                            className="modal-dialog modal-md"
                          >
                            <div className="modal-content back">
                              <div className="modal-body">
                                <table>
                                  <tbody>
                                    <tr>
                                      <td>&nbsp;</td>
                                      <th colspan="3"></th>
                                    </tr>
                                    <tr>
                                      <td>ODDS</td>
                                      <td colspan="2">
                                        <div className="input-group mt-2">
                                          <div className="input-group-prepend">
                                            <button
                                              type="button"
                                              className="btn btn-outline-secondary"
                                            >
                                              <strong>-</strong>
                                            </button>
                                          </div>
                                          <input
                                            type="number"
                                            id="bet-price"
                                            step="0.01"
                                            min="1.01"
                                            max="1000"
                                            className="form-control"
                                          />
                                          <div className="input-group-append">
                                            <button
                                              type="button"
                                              className="btn btn-outline-secondary"
                                            >
                                              <strong>+</strong>
                                            </button>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Amount</td>
                                      <td colspan="2">
                                        <input
                                          type="number"
                                          id="bet-size-m"
                                          className="form-control mt-2"
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{ width: "25%" }}>
                                        <button
                                          type="button"
                                          data-amount="2000"
                                          className="btn btn-secondary btn-block mt-2"
                                          style={{
                                            touchAction: "manipulation"
                                          }}
                                        >
                                          2,000
                                        </button>
                                      </td>
                                      <td style={{ width: "25%" }}>
                                        <button
                                          type="button"
                                          className="btn btn-secondary btn-block mt-2"
                                          style={{
                                            touchAction: "manipulation"
                                          }}
                                        >
                                          5,000
                                        </button>
                                      </td>
                                      <td style={{ width: "25%" }}>
                                        <button
                                          type="button"
                                          className="btn btn-secondary btn-block mt-2"
                                          style={{
                                            touchAction: "manipulation"
                                          }}
                                        >
                                          10,000
                                        </button>
                                      </td>
                                      <td style={{ width: "25%" }}>
                                        <button
                                          type="button"
                                          className="btn btn-secondary btn-block mt-2"
                                          style={{
                                            touchAction: "manipulation"
                                          }}
                                        >
                                          25,000
                                        </button>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <button
                                          type="button"
                                          className="btn btn-secondary btn-block mt-2"
                                          style={{
                                            touchAction: "manipulation"
                                          }}
                                        >
                                          +1,000
                                        </button>
                                      </td>
                                      <td>
                                        <button
                                          type="button"
                                          className="btn btn-secondary btn-block mt-2"
                                          style={{
                                            touchAction: "manipulation"
                                          }}
                                        >
                                          +5,000
                                        </button>
                                      </td>
                                      <td>
                                        <button
                                          type="button"
                                          className="btn btn-secondary btn-block mt-2"
                                          style={{
                                            touchAction: "manipulation"
                                          }}
                                        >
                                          +10,000
                                        </button>
                                      </td>
                                      <td>
                                        <button
                                          type="button"
                                          className="btn btn-secondary btn-block mt-2"
                                          style={{
                                            touchAction: "manipulation"
                                          }}
                                        >
                                          +25,000
                                        </button>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <button
                                          type="button"
                                          data-dismiss="modal"
                                          className="btn btn-danger mt-2"
                                          style={{
                                            touchAction: "manipulation"
                                          }}
                                        >
                                          Close
                                        </button>
                                      </td>
                                      <td colspan="2">
                                        <div
                                          className="btn btn-primary ld-over mt-2"
                                          style={{ cursor: "pointer" }}
                                        >
                                          <b>Submit</b>
                                          <div className="ld ld-ball ld-flip"></div>
                                        </div>
                                        <span> / -</span>
                                      </td>
                                    </tr>
                                    <tr style={{ display: "none" }}>
                                      <td
                                        colspan="4"
                                        className="alert-danger pr-5"
                                      ></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="bets">
                        <strong style={{ color: "white" }}>
                          Matched Bets ({totalBets})
                        </strong>
                        <div className="betting-table">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Runner</th>
                                <th>Price</th>
                                <th>Size</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody id="refreshhistory">
                              {betList.length > 0 ? (
                                betList.map((item, index) => (
                                  <tr
                                    style={{
                                      background:
                                        item.type == "b"
                                          ? "#e9f6fc"
                                          : "#fce3e4",
                                      color: "#000",
                                      fontSize: "15px",
                                      textAlign: "center"
                                    }}
                                  >
                                    <td
                                      style={{
                                        textAlign: "left",
                                        padding: "15px",
                                        display: "table-cell",
                                        padding: "5px"
                                      }}
                                    >
                                      {item.rnr !== "" ? (
                                        item.rnr == "runner1b1" ||
                                        item.rnr == "runner1b2" ||
                                        item.rnr == "runner1b3" ||
                                        item.rnr == "runner1l1" ||
                                        item.rnr == "runner1l2" ||
                                        item.rnr == "runner1l3" ? (
                                          <span>Player 1</span>
                                        ) : item.rnr == "runner2b1" ||
                                          item.rnr == "runner2b2" ||
                                          item.rnr == "runner2b3" ||
                                          item.rnr == "runner2l1" ||
                                          item.rnr == "runner2l2" ||
                                          item.rnr == "runner2l3" ? (
                                          <span>Player 2</span>
                                        ) : item.rnr == "runner3b1" ||
                                          item.rnr == "runner3b2" ||
                                          item.rnr == "runner3b3" ||
                                          item.rnr == "runner3l1" ||
                                          item.rnr == "runner3l2" ||
                                          item.rnr == "runner3l3" ? (
                                          <span>Player 3</span>
                                        ) : item.rnr == "runner4b1" ||
                                          item.rnr == "runner4b2" ||
                                          item.rnr == "runner4b3" ||
                                          item.rnr == "runner4l1" ||
                                          item.rnr == "runner4l2" ||
                                          item.rnr == "runner4l3" ? (
                                          <span>Player 4</span>
                                        ) : item.rnr == "runner5b1" ||
                                          item.rnr == "runner5b2" ||
                                          item.rnr == "runner5b3" ||
                                          item.rnr == "runner5l1" ||
                                          item.rnr == "runner5l2" ||
                                          item.rnr == "runner5l3" ? (
                                          <span>Dealer wins or ties all</span>
                                        ) : item.rnr == "runner6b1" ||
                                          item.rnr == "runner6b2" ||
                                          item.rnr == "runner6b3" ||
                                          item.rnr == "runner6l1" ||
                                          item.rnr == "runner6l2" ||
                                          item.rnr == "runner6l3" ? (
                                          <span>One or more has 5 cards</span>
                                        ) : item.rnr == "runner7b1" ||
                                          item.rnr == "runner7b2" ||
                                          item.rnr == "runner7b3" ||
                                          item.rnr == "runner7l1" ||
                                          item.rnr == "runner7l2" ||
                                          item.rnr == "runner7l3" ? (
                                          <span>All cards unique</span>
                                        ) : item.rnr == "runner8b1" ||
                                          item.rnr == "runner8b2" ||
                                          item.rnr == "runner8b3" ||
                                          item.rnr == "runner8l1" ||
                                          item.rnr == "runner8l2" ||
                                          item.rnr == "runner8l3" ? (
                                          <span>Only one has 21pts</span>
                                        ) : (
                                          <span></span> // For any other value
                                        )
                                      ) : (
                                        <span></span>
                                      )}
                                      - {item.cat_mid}
                                    </td>
                                    <td
                                      style={{
                                        display: "table-cell",
                                        textAlign: "left",
                                        padding: "5px"
                                      }}
                                    >
                                      {item.rate}
                                    </td>
                                    <td
                                      style={{
                                        display: "table-cell",
                                        textAlign: "left",
                                        padding: "5px"
                                      }}
                                    >
                                      {item.amnt}
                                    </td>
                                    <td></td>
                                  </tr>
                                ))
                              ) : (
                                <tr></tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </AgentLayout>
    );
};

export default AgentBetfairTurboBlackjack;


